module.exports = __webpack_public_path__ + "static/img/21红蝠.1477b5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/21红蝠.jpg
// module id = Ql5B
// module chunks = 1